<template>
  <BaseModal
    :show="show"
    :show-close-icon="false"
    @close="handleCancel"
  >
    <div
      slot="header"
      v-text="`Verify Mobile Number`"
    />
    <template slot="body">
      <p v-text="message" />
      <div class="w-1/4 mx-auto mt-4">
        <input
          id="auth_code"
          v-model="form.auth_code"
          autofocus
          :class="{ error }"
          name="auth_code"
          placeholder="000000"
          required
          type="number"
          autocomplete="off"
        >
      </div>
      <span
        v-if="error"
        class="help-block mx-8 mt-4"
        v-text="error"
      />
    </template>
    <button
      slot="confirm"
      type="button"
      class="btn"
      :class="{ 'load': form.busy }"
      :disabled="!form.auth_code"
      :aria-disabled="!form.auth_code"
      @click="submit"
      v-text="form.busy ? 'Verifying' : 'Verify'"
    />
  </BaseModal>
</template>

<script type="text/babel">
import MUMForm from 'Base/Resources/assets/js/MUMForm'

export default {
  name: 'ConfirmNumberModal',
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    authCodeId: {
      type: String,
      required: true,
    },
    message: {
      type: String,
      required: false,
      default: 'Please enter the 6 digit authorization code that we just sent to your mobile number.',
    },
  },
  data() {
    return {
      error: null,
      form: new MUMForm({
        auth_code: null,
      }),
    }
  },
  methods: {
    submit() {
      this.error = null

      this.form.startProcessing()

      this.$api.public()
        .post(`/auth-codes/${this.authCodeId}/verify`, this.form)
        .then(({ data }) => {
          this.form.finishProcessing()

          this.form.auth_code = null
          this.errors = null

          this.$emit('codeIsValid', data.confirmation)
        })
        .catch((errors) => {
          try {
            this.form.finishProcessing()

            this.error = errors.response.data.message
          } catch (error) {
            this.error = 'There was a problem validating the code. Please refresh and try again.'
          }
        })
    },
    handleCancel() {
      this.form.auth_code = null
      this.errors = null

      this.$emit('cancel')
    },
  },
}
</script>
